export function loadBMap() {
    const bmap = new Promise(function(resolve, reject) {
        if (typeof BMap !== 'undefined') {
            // eslint-disable-next-line
            resolve(BMap);
            return true;
        }
        window.onBMapCallback = function() {
            // eslint-disable-next-line
            resolve(BMap);
        };
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src =
        'https://api.map.baidu.com/api?v=2.0&ak=' + '6N54N3ujNCfK9bKovNfqRcOnCHuoBoX7' + '&s=1&callback=onBMapCallback';
        script.onerror = reject;
        document.head.appendChild(script);
    });
    const bmapLib = new Promise(function(resolve, reject) {
        const script2 = document.createElement('script');
        script2.type = 'text/javascript';
        script2.src =
        'https://api.map.baidu.com/library/LuShu/1.2/src/LuShu_min.js';
        script2.onerror = reject;
        script2.onload = function() {
            resolve(window.BMapLib);
        };
        document.head.appendChild(script2);
    });
    return Promise.all([bmap, bmapLib])
        .then(function (result) {
            return result;
        }).catch(e => {
        });
}

/**
 * @description 加载百度地图相关资源js
 * @param {string} ak
 */
// export default function loadBMap(ak) {
//     return new Promise((resolve, reject) => {
//         asyncLoadBaiduJs(ak).then(() => {
//             asyncLoadJs('https://api.map.baidu.com/library/LuShu/1.2/src/LuShu_min.js').then(() => {
//                 resolve();
//                 return true;
//             }).catch(err => {
//                 reject(err);
//             });
//         }).catch(err => {
//             reject(err);
//         });
//     });
// }
// /**
//  * @description 加载百度地图
//  * @param {string} ak
//  */
// export function asyncLoadBaiduJs(ak) {
//     return new Promise((resolve, reject) => {
//         if (typeof BMap !== 'undefined') {
//             // eslint-disable-next-line
//             resolve(BMap);
//             return true;
//         }
//         window.onBMapCallback = function () {
//             // eslint-disable-next-line
//             resolve(BMap);
//         };
//         const script = document.createElement('script');
//         script.type = 'text/javascript';
//         script.src = 'https://api.map.baidu.com/api?v=2.0&ak=' + '6N54N3ujNCfK9bKovNfqRcOnCHuoBoX7' + '&callback=onBMapCallback';
//         script.onerror = reject;
//         document.head.appendChild(script);
//     });
// }
// export function asyncLoadJs(url) {
//     return new Promise((resolve, reject) => {
//         const script = document.createElement('script');
//         script.type = 'text/javascript';
//         script.src = url;
//         document.head.appendChild(script);
//         script.onload = () => {
//             resolve();
//         };
//         script.onerror = reject;
//     });
// }